import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PresentationApp from "@/presentation/PresentationApp";
import PresenterView from "@/presentation/PresenterView";
import PasscodeGate from "@/presentation/PasscodeGate";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <PasscodeGate>
          <Routes>
            <Route path="/" element={<PresentationApp />} />
            <Route path="/presenter" element={<PresenterView />} />
          </Routes>
        </PasscodeGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
